import { render, staticRenderFns } from "./BasicRFIDDevice.vue?vue&type=template&id=1bd05f68&scoped=true&"
import script from "./BasicRFIDDevice.vue?vue&type=script&lang=js&"
export * from "./BasicRFIDDevice.vue?vue&type=script&lang=js&"
import style0 from "./BasicRFIDDevice.vue?vue&type=style&index=0&id=1bd05f68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd05f68",
  null
  
)

export default component.exports